import React from "react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function Result(props) {
  const [userData, setUserData] = useState(null);
  const [userName, setName] = useState("There");
  const [BMI, setBMI] = useState(null);

  const location = useLocation();

  useEffect(() => {
    setUserData(location.userData.detail);
    setName(location.usersName);
    setBMI(location.bmi);
  }, [location]);

  if (!userData) {
    return <h1>Loading...</h1>;
  }

  return (
    <div className="data-list">
      <h1> Hello {userName}</h1>
      <p> Artery- {userData.artery}</p>
      <p>Liver- {userData.liver}</p>
      <p>Malignancy- {userData.malignancy}</p>
      <p>pulmonary- {userData.pulmonary}</p>
      <p>resp- {userData.resp}</p>
      <p>stroke- {userData.stroke}</p>

      <h4>Your bmi is {BMI.toFixed(2)}</h4>
    </div>
  );
}

export default Result;
